<template>
    <div class="head">
        <!-- 左侧 Logo 和文字 -->
        <div class="head-left">
            <div class="head-left-img" @click="gohome">
                <img src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/head/logo-dark.png?x-oss-process=image/format,webp" alt="LANYVE Logo" >
            </div>
        </div>
        <!-- 右侧按钮区域 -->
        <div class="head-right" >
            <div class="wechat-icon" @click="toggleProduct">
                <!-- <img src="https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/head/Contact.png?x-oss-process=image/format,webp" alt=""> -->
                 <img src="@/assets/Frame.png" alt="">
            </div>
        </div>        
        <Product v-if="showProduct" class="product-dropdown-content" @close="handleCloseProduct"/>
    </div>

</template>

<script>
import Product from '@/components/mobile_components/product.vue'
export default {
    components: {
        Product
    },
    name: 'HeaderComponent',
    props: {

  },
  data() {
        return {
            showProduct: false,
            solutionDropdownOpen: false,
            resourceDropdownOpen: false,
            dropdownTimeout: null,
            showQR: false, // 控制二维码显示
            qrCodeImage:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/ConsultNow.png?x-oss-process=image/format,webp',
            qrcode:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/Vector.png?x-oss-process=image/format,webp'
        }
    },
    methods: {
        toggleProduct() {
            this.showProduct = !this.showProduct;
            // 防止页面滚动
            document.body.style.overflow = this.showProduct ? 'hidden' : '';
        },
        handleCloseProduct() {
            this.showProduct = false;
            document.body.style.overflow = '';
        },
        gohome() {
            if (this.$route.path === '/') {
                return;
            }
            this.$router.push('/')
            this.showProduct = false;
        },

        showResourceDropdown() {
        if (this.dropdownTimeout) {
            clearTimeout(this.dropdownTimeout);
            this.dropdownTimeout = null;
        }
        this.resourceDropdownOpen = true;
    },
    hideResourceDropdown() {
        this.dropdownTimeout = setTimeout(() => {
            this.resourceDropdownOpen = false;
        }, 200);
    },
    
    closeResourceDropdown() {
        this.resourceDropdownOpen = false;
    },
        toggleSolutionDropdown() {
            this.solutionDropdownOpen = !this.solutionDropdownOpen;
        },
        showSolutionDropdown() {
            // 清除可能存在的隐藏定时器
            if (this.dropdownTimeout) {
                clearTimeout(this.dropdownTimeout);
                this.dropdownTimeout = null;
            }
            this.solutionDropdownOpen = true;
        },
        hideSolutionDropdown() {
            // 设置一个短暂的延迟，让用户能够点击下拉菜单项
            this.dropdownTimeout = setTimeout(() => {
                this.solutionDropdownOpen = false;
            }, 200);
        },
        closeDropdown() {
            this.solutionDropdownOpen = false;
        },
                showQRCode() {
            this.showQR = true;
            // 防止页面滚动
            document.body.style.overflow = 'hidden';
        },
    },
    // 当路由变化时关闭下拉菜单
    watch: {
        $route() {
            this.solutionDropdownOpen = false;
        }
    }

}
</script>

<style scoped>
.head {
    display: flex;
    position: fixed;
    top: 0;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    color: black;
    width: 100%;
    height: 300px;
    z-index: 99;
    transition: all 0.3s ease;
}

.product-dropdown-content{
    z-index: 1000;
}
.head-left {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: 81.9px;
}

.head-right {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #FFFFFF;
    margin-right: 81.9px;
    /* 增加右侧外边距 */
}
.head-right img{
    width: 503px;
}

.head-left-img {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.head-left-img img {
    z-index: 1000;
    width: 503px;
    position: relative;
}

.wechat-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.wechat-icon img {
    width: 108px;
    height: 108px;
}

.head-left-text {
    text-align: left;
}

.head-left-text-title {
    font-size: 20px;
    font-weight: bold;
}

.head-left-text-content {
    font-size: 14px;
    opacity: 0.8;
}

.head-center {
    display: flex;
    align-items: center;
}

.nav-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 38px;
}

.nav-menu li a {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center; /* 垂直居中 */
    font-size: 16px;
    position: relative;
    padding: 8px 0;
}

.qr-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.qr-popup {
    border-radius: 8px 24px 24px 8px;
    background: white;
    text-align: center;
    position: relative;
}

.qr-header {
    position: absolute;
    display: flex;
    top: 16px;
    /* left: 900px; */
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

/* .qr-header span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
} */

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn:hover {
    color: #333;
}

.qr-image {

    display: block;
}

.qr-description {
    font-size: 14px;
    color: #666;
    margin: 0;
}

/* .nav-menu li.active a::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 2px;
    z-index: 1000;
    background-color: white;
    transition: all 0.3s ease;
} */

.wechat-icon svg {
    width: 20px;
    height: 20px;
}

.consultation-btn {
    position: relative;
    display: flex;
    height: 32px;
    padding: 9.5px 33px 9.5px 33px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    text-align: center;
    font-family: "Microsoft YaHei";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; 
    letter-spacing: 2.56px; 
    z-index: 1;
    border: none; /* 移除真正的边框 */
    box-shadow: inset 0 0 0 1px #000; /* 使用内阴影创建边框效果 */
    -webkit-font-smoothing: antialiased;
    backface-visibility: hidden;   
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.consultation-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    border-radius: 4px;
    height: 100%;
    background: #3985e7ff; /* 蓝色背景 */
    transition: width 0.3s ease;
    z-index: -1;
}

.consultation-btn:hover::before {
    width: 100%;
}

.consultation-btn:hover {
    color: #FFFFFF; 
    cursor: pointer;
    box-shadow: inset 0 0 0 1px transparent; /* 悬停时隐藏边框效果 */
}

/* 滚动状态下的样式 */
.head.scrolled .consultation-btn {
    box-shadow: inset 0 0 0 1px #333; /* 滚动后深色边框效果 */
    color: #333;
    background: #FFF;
}

.head.scrolled .consultation-btn:hover {
    color: #FFFFFF;
    box-shadow: inset 0 0 0 1px transparent; /* 滚动状态下悬停时也隐藏边框 */
}

/* 非滚动状态下的白色主题样式 */
.head:not(.scrolled) .consultation-btn {
    box-shadow: inset 0 0 0 1px #FFFFFF; /* 未滚动时白色边框效果 */
    color: white;
    background: transparent;
}

.head:not(.scrolled) .consultation-btn::before {
    background: #3985e7ff;
}

.head:not(.scrolled) .consultation-btn:hover {
    color: #000;
    box-shadow: inset 0 0 0 1px transparent; /* 未滚动状态下悬停时也隐藏边框 */
}


.header {
    background-color: transparent;
    transition: background-color 0.3s ease;
}

.header.scrolled {
    background-color: white;
}

/* .nav-menu li a:hover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: white;
} */
.head.scrolled .nav-menu li.active a::after {
    background-color: #333; /* 滚动后使用深色下划线 */
}

.head.scrolled .nav-menu li a:hover::after {
    background-color: #333; /* 滚动后悬停也使用深色 */
}

.head.scrolled .nav-menu li a {
    color: #333; /* 滚动后文字颜色变深 */
}


.dropdown-menu {
    position: relative;
}

.dropdown-menu a {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
    font-size: 16px;
    position: relative;
}

.dropdown-content {
    position: absolute;
    left: -50px;
    height: 176px;
    background-color: white;
    border-radius: 8px;
    min-width: 190px;
    padding: 16px;
    z-index: 1000;
    overflow: hidden;
}
.dropdown-content-1 {
    position: absolute;
    left: -50px;
    background-color: white;
    border-radius: 8px;
    min-width: 190px;
    padding: 16px;
    z-index: 1000;
    overflow: hidden;
}

.solution-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 0 !important;   
}

.solution-list-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 0 !important;   
}

.solution-list li {
    align-items: center;
    width: 100%;
    align-self: stretch;
}

.solution-list-1 li {
    align-items: center;
    width: 100%;
    align-self: stretch;
}

.solution-list-1 li a {
    color: #333;
    padding: 10px;
    text-decoration: none;
    display: block;
    transition: all 0.3s ease;
}

.solution-list li a {
    color: #333;
    padding: 10px;
    text-decoration: none;
    display: block;
    transition: all 0.3s ease;
}

.head.scrolled .solution-list-1 li a:hover {
    background-color: #f5f5f5;
    color: #1C9AF3;
    
}

.head.scrolled .solution-list-1 li a {
    color: #333;
}

.head.scrolled .dropdown-content {
    background-color: white;
}

.head.scrolled .dropdown-content-1 {
    background-color: white;
}

.head.scrolled .solution-list li a {
    color: #333;
}

.head.scrolled .solution-list li a:hover {
    background-color: #f5f5f5;
    color: #1C9AF3;
    
}

.solution-list-1 li a:hover {
    background-color: #f5f5f5;
    color: #1C9AF3;

}

/* 修复当前活动状态的下划线 */
.nav-menu li.active a::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 2px;
    z-index: 1000;
    background-color: white;
    transition: all 0.3s ease;
}

.head.scrolled .nav-menu li.active a::after {
    background-color: #333;
}
.dropdown-content.resource-content {
    left: -50px; /* 调整水平位置 */
    top: calc(100% + 8px); /* 调整垂直位置 */
}
.dropdown-content-1.resource-content {
    left: -50px; /* 调整水平位置 */
    top: calc(100% + 8px); /* 调整垂直位置 */
}
.solution-list li a:hover {
    background-color: #f5f5f5;
    color: #1C9AF3;

}

/* 修改 Element UI Popover 样式 - 方法1：使用深度选择器（在 scoped 中） */
::v-deep .el-popover {
    padding: 0 !important;
    border: none !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

/* 方法2：使用 popper-class 指定的类名（全局样式，不受 scoped 限制） */
</style>

<style>
/* 全局样式：修改 Element UI 组件样式（不受 scoped 限制） */
.custom-product-popover {
    padding: 0 !important;
    border: none !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
    border-radius: 8px !important;
    max-width: 1600px !important;
}

/* 其他 Element UI 组件样式覆盖示例 */
/* 
.el-button {
    border-radius: 4px;
}

.el-input__inner {
    border-color: #1C9AF3;
}

.el-dialog {
    border-radius: 8px;
}
*/
</style>